export const teamMemberCheck = (teamsList, empID, originalTeamID) => {
	let isTeamMember = false;
	
	teamsList.some(team => {
		if ('T'+team.TeamCode === originalTeamID) {
			isTeamMember = team.TeamMembers.find(memberID => memberID === empID);
		}

		return isTeamMember;
	});

	return isTeamMember;
};